import { render, staticRenderFns } from "./Payrates.vue?vue&type=template&id=4a519daf&scoped=true&"
import script from "./Payrates.vue?vue&type=script&lang=js&"
export * from "./Payrates.vue?vue&type=script&lang=js&"
import style0 from "./Payrates.vue?vue&type=style&index=0&id=4a519daf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a519daf",
  null
  
)

export default component.exports